module.exports = __webpack_public_path__ + "static/media/bindu.d0ab4186.png";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/bindu.png
// module id = 534
// module chunks = 0